import { Box, Stack } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import DeleteAlert from "../../../components/Alert/DeleteAlert";
import AppLoader from "../../../components/AppLoader";
import PaperContainer from "../../../components/Containers/PaperContainer";
import GlobalButton from "../../../components/CustomButton";
import AddEditAdminUserDialog from "../../../components/Dialogs/AddEditAdminUserDialog";
import GlobalTable from "../../../components/Tables/GlobalTable";
import {
  deleteAdminUser,
  getAllAdminUsers,
} from "../../../services/adminUserApiFn";
import { getAllAdminRole } from "../../../services/roleApiFn";
import { handleOpenSnackBar } from "../../../utils";
import { t } from "i18next";
import { useTranslation } from "react-i18next";

const headerData = [
  "name",
  "email",
  "contact",
  "role",
  "assignedPages",
  "actions",
];

const tableRows = [
  "name",
  "email",
  "contact",
  "admin_user_role",
  "assigned_pages",
  "actions",
];

function AllUsers() {
  const openDialog = useRef();
  const openDeleteDialog = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [allRole, setAllRole] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const { t } = useTranslation(["setting", "common"]);

  useEffect(() => {
    fetchAllAdminRole();
    fetchAllAdminUsers();
  }, []);

  const fetchAllAdminRole = async () => {
    try {
      setIsLoading(true);
      const response = await getAllAdminRole();
      if (response.data.status === "success") {
        const data = response.data.data;
        setAllRole(data);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAllAdminUsers = async () => {
    try {
      setIsLoading(true);
      const response = await getAllAdminUsers();
      if (response.data.status === "success") {
        const data = response.data.data;
        setAllUsers(data);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditUsers = (row, ind) => {
    openDialog.current.openDialog({
      type: "edit",
      data: row,
      getData: fetchAllAdminUsers,
    });
  };

  const handleOpenDeleteDialog = (params) => {
    openDeleteDialog.current.openDialog({
      data: params.row,
      warningText: t("deleteUserConfirmation"),
    });
  };

  const handleDelete = async (params) => {
    try {
      setIsLoading(true);
      const response = await deleteAdminUser(params.data._id);
      if (response.data.status) {
        openDeleteDialog.current.closeDialog();
        fetchAllAdminUsers();
        handleOpenSnackBar("success", response.data.message);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const renderHeaderActions = () => {
    return (
      <Stack
        gap={2}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <Box height={40}>
          <GlobalButton
            variant={"contained"}
            btnText={"createUser"}
            styleProps={{ fontWeight: 400, width: "auto" }}
            handleClickBtn={() =>
              openDialog.current.openDialog({
                type: "add",
                data: null,
                getData: fetchAllAdminUsers,
              })
            }
          />
        </Box>
      </Stack>
    );
  };
  return (
    <>
      <AppLoader isVisible={isLoading} />
      <PaperContainer
        title={t("createUser")}
        subtitle={t("usersManagementInfo")}
        headerActions={renderHeaderActions()}
      >
        <GlobalTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={allUsers}
          showActions={true}
          showDelete={true}
          handleDelete={handleOpenDeleteDialog}
          showAdminUserPage={true}
          showEdit={true}
          handleEdit={handleEditUsers}
        />
      </PaperContainer>
      <AddEditAdminUserDialog ref={openDialog} allRole={allRole} />
      <DeleteAlert ref={openDeleteDialog} handleDelete={handleDelete} />
    </>
  );
}

export default AllUsers;
